module.exports = __webpack_public_path__ + "static/media/static.07917c1c.gif";